/* eslint-disable no-const-assign */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Loader from "../../animation/Loader.json";
import { toast } from "react-toastify";
import Header from "../../Common/Navbar";
import { FaChevronLeft } from "react-icons/fa";

export const ApplicationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const { role } = useSelector((state) => state.authSlice.userInfo.user);
  const [members, setMembers] = useState();
  const [isLoading, setIsLoading] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [memberData, setMemberData] = useState();
  const [willingToStudyCount, setWillingToStudyCount] = useState(0);
  const [permanentMedicationCount, setPermanentMedicationCount] = useState(0);
  const [overSixteenCount, setOverSixteenCount] = useState(0);
  const [underSixteenCount, setUnderSixteenCount] = useState(0);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`family/${id}/`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setData(result?.data);
        console.log("family detail :", result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
      toast.error(error?.response?.data?.detail);
    }
  };

  const fetchFamilyData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`family_detail/${id}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) {
        setMembers(result?.data);
        console.log("member result :///", result?.data);
      }
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.detail);
    }
  };

  const fetchFamilyMembers = async () => {
    try {
      const result = await fetchApi.get(`member/?family__id=${id}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) setMemberData(result?.data);
      
      // Calculate counts
      let willingCount = 0;
      let medicationCount = 0;
      let overSixteen = 0;
      let underSixteen = 0;

      result.data.results.forEach((member) => {
        if (member?.willing_to_study) willingCount++;
        if (member?.permanent_medication) medicationCount++;
        if (member?.age > 16) overSixteen++;
        if (member?.age <= 16) underSixteen++;
      });

      setWillingToStudyCount(willingCount);
      setPermanentMedicationCount(medicationCount);
      setOverSixteenCount(overSixteen);
      setUnderSixteenCount(underSixteen);

    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchFamilyData();
    fetchFamilyMembers();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const ViewMemberfunc = (id) => {
    navigate(`/memberlistingdetail/${id}`);
    console.log("id", id);
  };

  console.log("user Role", role);

  const handleStatus = async (e) => {
    setData((prev) => ({ ...prev, status: e.target.id }));
    const updatedStatus = e.target.id;
    const data = new FormData();
    data.append("status", updatedStatus);
    try {
      const result = await fetchApi.patch(`family/${id}/`, data, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) {
        navigate(-1);
      }
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.detail);
    }
  };

  return (
    <>
      <Header parent={'family'}/>
      <div className="mt-20" style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
        {/* Back Button */}
        <button className="back-button-new" onClick={handleGoBack}>
          <FaChevronLeft size={24} />
        </button>
        
        {isLoading ? (
          <div className="flex justify-center items-center h-screen">
            <Lottie
              loop={true}
              animationData={Loader}
              style={{ width: "200px" }}
              className="auth-sidebar-video"
            />
          </div>
        ) : (
          <div className="member-detail-wrapper">
            {/* Profile Header Section */}
            <div className="profile-header-section flex justify-between md:items-end items-start gap-4">
              <div className="info w-full gap-2">
                <div className="profile-avatar-container">
                  <div className="profile-avatar">
                    <span className="avatar-text">
                      {data?.name?.charAt(0)}
                    </span>
                  </div>
                </div>
                <div className="w-full flex flex-col items-start">
                  <div className="flex justify-between items-center gap-2 w-full">
                    <h1 className="profile-name">
                      {data?.name}
                    </h1>
                  </div>

                  <div className="profile-badges">
                    <span className="badge badge-gender">
                      Male Members: {members?.male_members}
                    </span>
                    <span className="badge badge-status">
                      Female Members: {members?.female_members}
                    </span>
                    <span className="badge badge-gender">
                      Total Members: {members?.total_members}
                    </span>
                    <span className="badge badge-gender">
                      Priority: {data?.application_priority}
                    </span>
                  </div>
                </div>
              </div>

              {/* Status Dropdown */}
              <div className="relative">
                <div className="font-sublabel mb-2">
                  <b>Status</b>
                </div>
                {role === "admin" ? (
                  <div className="relative capitalize">
                    <button
                      className="primary-button flex items-center gap-2 capitalize"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      {data?.status}
                      <svg 
                        className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    <div
                      className={`absolute top-full right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-10 transition-all duration-200 flex  ${
                        isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
                      }`}
                    >
                      <div className="py-1 min-w-[120px] flex flex-col gap-1">
                        <span
                          className="w-full text-left px-4 py-2 hover:bg-gray-100 capitalize"
                          onClick={(e) => {
                            handleStatus(e);
                            setIsOpen(false);
                          }}
                          id="accepted"
                        >
                          Accepted
                        </span>
                        <span
                          className="w-full text-left px-4 py-2 hover:bg-gray-100 capitalize"
                          onClick={(e) => {
                            handleStatus(e);
                            setIsOpen(false);
                          }}
                          id="rejected"
                        >
                          Rejected
                        </span>
                        <span
                          className="w-full text-left px-4 py-2 hover:bg-gray-100 capitalize"
                          onClick={(e) => {
                            handleStatus(e);
                            setIsOpen(false);
                          }}
                          id="in-review"
                        >
                          In-review
                        </span>
                        <span
                          className="w-full text-left px-4 py-2 hover:bg-gray-100 capitalize"
                          onClick={(e) => {
                            handleStatus(e);
                            setIsOpen(false);
                          }}
                          id="hold"
                        >
                          Hold
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <span className="primary-button capitalize">
                    {data?.status}
                  </span>
                )}
              </div>
            </div>

            {/* Main Content Grid */}
            <div className="content-grid">
              {/* Left Column - Family Statistics */}
              <div className="info-section">
                <h2 className="section-title md:w-1/3 w-2/5">
                  Family Statistics
                </h2>
                <div className="w-3/5 md:w-2/3">
                  <div className="info-row">
                    <span className="info-row-label">Willing to Study</span>
                    <span className="info-row-value">{willingToStudyCount}</span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">Permanent Medication</span>
                    <span className="info-row-value">{permanentMedicationCount}</span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">Over Sixteen</span>
                    <span className="info-row-value">{overSixteenCount}</span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">Under Sixteen</span>
                    <span className="info-row-value">{underSixteenCount}</span>
                  </div>
                </div>
              </div>

              {/* Right Column - Location Information */}
              <div className="info-section">
                <h2 className="section-title md:w-1/3 w-2/5">
                  Location Information
                </h2>
                <div className="w-3/5 md:w-2/3">
                  <div className="info-row highlighted">
                    <span className="info-row-label">Pin Location</span>
                    <span className="info-row-value">
                      {data?.pin_location || "N/A"}
                    </span>
                  </div>

                  <div className="info-row">
                    <span className="info-row-label">Status Statement</span>
                    <span className="info-row-value">
                      {data?.status_statement || "N/A"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Members Section */}
            <div className="full-width md:mt-6 mt-4">
              <h2 className="section-title mb-6">Family Members</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {memberData?.results?.map((item) => (
                  <div key={item?.id} className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-16 h-16 rounded-full bg-primary-green/10 flex items-center justify-center">
                        <img
                          src={require(`../../assets/${item?.gender === "Male" ? "man" : "woman"}.png`)}
                          alt={item?.gender}
                          className="w-12 h-12 rounded-full object-cover"
                        />
                      </div>
                      <div>
                        <h3 className="font-semibold text-lg text-gray-900">
                          {item?.first_name} {item?.last_name}
                        </h3>
                        <p className="text-sm text-gray-600">{item?.gender}</p>
                      </div>
                    </div>

                    <div className="space-y-3 mb-4">
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-700">CNIC</span>
                        <span className="text-sm text-gray-900">{item?.cnic_number || "N/A"}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-700">Education</span>
                        <span className="text-sm text-gray-900 capitalize">{item?.education_or_qualification}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-700">Willing to Study</span>
                        <span className="text-sm text-gray-900">{item?.willing_to_study ? "Yes" : "No"}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-700">Medication</span>
                        <span className="text-sm text-gray-900">{item?.permanent_medication ? "Yes" : "No"}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-700">Age</span>
                        <span className="text-sm text-gray-900">{item?.age}</span>
                      </div>
                    </div>

                    <button
                      onClick={() => ViewMemberfunc(item?.id)}
                      className="w-full primary-button py-2 rounded-full hover:bg-opacity-90 transition-colors"
                    >
                      View Details
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};